// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"8d76eeee","640":"b4446c1d"}[chunkId] + ".css";
};